import { render, staticRenderFns } from "./PagesOverview.vue?vue&type=template&id=c747425a&scoped=true&"
import script from "./PagesOverview.vue?vue&type=script&lang=js&"
export * from "./PagesOverview.vue?vue&type=script&lang=js&"
import style0 from "./PagesOverview.vue?vue&type=style&index=0&id=c747425a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c747425a",
  null
  
)

export default component.exports